import { atom } from "recoil"

export const userAtom = atom({
    key: "userAtom",
    default: null
})

export const registerEmailAtom = atom({
    key: "registerEmail",
    default: null
})
